import { Component, Input } from '@angular/core';
import { ModelStrategyInstrumentOut } from '../../charts/charts';
import { instrumentCategoryColors } from '../../constants';
import { DropdownPortfolioRatios } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-dropdown-list-item',
  templateUrl: './dropdown-list-item.component.html',
  styleUrls: ['./dropdown-list-item.component.scss'],
  standalone: false
})
export class DropdownListItemComponent {
  @Input() public instrument?: ModelStrategyInstrumentOut;
  @Input() public instrumentRatios?: DropdownPortfolioRatios | null; // only used in investment detail

  public instrumentCategoryColors = instrumentCategoryColors;

  public toggled = false;

  public toggle(): void {
    this.toggled = !this.toggled;
  }
}
